// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__3r-_4","bubble":"styles_bubble__2_Rxc"};